import { useEffect, useState } from "react";
import Form from "../../../Components/Form";
import TextInput from "../../../Components/TextInput";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import {
  addOrEditCompetitionConfig,
  getCompetitionBlockSizePercent,
  getCompetitionInstrumentOptions,
  getStepInstruments,
  setCompetitionBlockSizePercent,
} from "../../../Requests/stepRequests";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import CompetitionConfigTable from "../../../Tables/Step/CompetitionConfig/CompetitionConfigTable";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setStepCompetitionConfigFormModalOpen,
  setStepCompetitionConfigFormValues,
  setStepCompetitionTableFlag,
  stepCompetitionConfigFormValuesChangeHandler,
} from "../../../Features/Step/stepSlice";
import {
  IStepCompetitionConfigFormValues,
  IStepCompetitionConfigTableReport,
} from "../../../Interfaces/stepInterfaces";
import { memo } from "react";
import { Add } from "@mui/icons-material";

const ModalUI = memo(() => {
  const formValues = useAppSelector(
    (store) => store.step,
  ).competitionConfigFormValues;
  const isFormModalOpen = useAppSelector(
    (store) => store.step,
  ).competitionConfigFormModalOpen;
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const [globalBlockSizePercent, setGlobalBlockSizePercent] = useState<
    number | null
  >(null);
  const [globalBlockSizeSaving, setGlobalBlockSizeSaving] = useState(false);

  useEffect(() => {
    getCompetitionBlockSizePercent()
      .then((resp) => setGlobalBlockSizePercent(resp.data))
      .catch(packetErrorHandler);
  }, []);

  const saveGlobalBlockSizePercent = () => {
    if (globalBlockSizePercent == null) return;
    setGlobalBlockSizeSaving(true);
    setCompetitionBlockSizePercent(globalBlockSizePercent)
      .then((resp) => toast.success(resp.msg))
      .catch(packetErrorHandler)
      .finally(() => setGlobalBlockSizeSaving(false));
  };

  const changeHandler = (name: string, value: any) => {
    dispatch(stepCompetitionConfigFormValuesChangeHandler({ name, value }));
  };

  const openAddForm = () => {
    dispatch(
      setStepCompetitionConfigFormValues(
        {} as IStepCompetitionConfigFormValues,
      ),
    );
    dispatch(setStepCompetitionConfigFormModalOpen(true));
  };

  const closeForm = () => {
    dispatch(setStepCompetitionConfigFormModalOpen(false));
  };

  const checkDisabled = () => {
    if (!formValues) return true;
    if (
      !formValues.activeOrderPP ||
      !formValues.insCode ||
      !formValues.totalActiveOrder ||
      !formValues.totalAmount
    )
      return true;
    return false;
  };

  const clickHandler = () => {
    setLoading(true);
    addOrEditCompetitionConfig(formValues)
      .then((resp) => {
        toast.success(resp.msg);
        dispatch(setStepCompetitionTableFlag(true));
        closeForm();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const tableRowClickHandler = (row: IStepCompetitionConfigTableReport) => {
    dispatch(
      setStepCompetitionConfigFormValues({
        activeOrderPP: row.activeOrderPP,
        insCode: row.insCode,
        totalActiveOrder: row.totalActiveOrder,
        totalAmount: row.totalAmount,
      }),
    );
    dispatch(setStepCompetitionConfigFormModalOpen(true));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-5 w-full">
      <div className="flex flex-row justify-between items-center w-full">
        <div className="flex flex-row justify-start items-end gap-2 w-fit p-2">
          <div className="w-24">
            <TextInput
              label="% بلوک به حداکثر حجم باز"
              value={globalBlockSizePercent?.toString() ?? ""}
              name="globalBlockSizePercent"
              onChange={(_, value) => setGlobalBlockSizePercent(value)}
              kind="percent"
              extraLabel
            />
          </div>
          <div className="w-16">
            <Button
              onClick={saveGlobalBlockSizePercent}
              text="ذخیره"
              variant="contained"
              disabled={globalBlockSizePercent == null}
              loading={globalBlockSizeSaving}
            />
          </div>
        </div>
        <div
          onClick={openAddForm}
          className="w-10 h-10 rounded-full bg-sky-600 hover:bg-sky-700 transition-all flex justify-center items-center cursor-pointer text-white"
        >
          <Add />
        </div>
      </div>
      {isFormModalOpen ? (
        <Modal title="تنظیمات کمین"
          onClose={closeForm}
          modalBoxClassName="!min-w-0 !w-auto"
          UI={
            <div className="flex justify-center items-center h-full">
              <Form className="p-3 gap-3 !w-60">
                <DynamicDropdown
                  dropdown={{
                    name: "insCode",
                    placeholder: "نماد",
                    extraLabel: true,
                  }}
                  onChange={changeHandler}
                  getData={getCompetitionInstrumentOptions}
                  value={formValues.insCode}
                />
                <TextInput
                  label="حداکثر تعداد سفارش باز"
                  value={formValues.totalActiveOrder?.toString()}
                  name="totalActiveOrder"
                  onChange={changeHandler}
                  kind="number"
                  extraLabel
                />
                <TextInput
                  label="حداکثر بلوک باز شخص"
                  value={formValues.activeOrderPP?.toString()}
                  name="activeOrderPP"
                  onChange={changeHandler}
                  kind="number"
                  extraLabel
                />
                <TextInput
                  label="حداکثر حجم باز"
                  value={formValues.totalAmount?.toString()}
                  name="totalAmount"
                  onChange={changeHandler}
                  kind="number"
                  extraLabel
                />
                <Button
                  onClick={clickHandler}
                  text="ثبت"
                  variant="contained"
                  disabled={checkDisabled()}
                  loading={loading}
                />
              </Form>
            </div>
          }
        />
      ) : (
        <></>
      )}
      <CompetitionConfigTable onTableRowClick={tableRowClickHandler} />
    </div>
  );
});

export default ModalUI;
